import events from 'events'

const READY = 'ready'
const WAITING = 'waiting'
const eventNames = [READY, WAITING]

export class AsyncResource {
  static READY = READY
  static WAITING = WAITING

  constructor(id, initialState = WAITING) {
    this.id = id
    if (!eventNames.includes(initialState)) {
      throw new Error(`Wrong initialState: ${initialState} provided`)
    }
    this.state = initialState
    this.emitter = new events.EventEmitter()
  }

  ready = () => {
    const prevState = this.state
    this.state = READY
    this._handleStateChange(prevState)
  }

  waiting = () => {
    const prevState = this.state
    this.state = WAITING
    this._handleStateChange(prevState)
  }

  isReady() {
    return this.state === READY
  }

  on(eventName, listener) {
    if (!eventNames.includes(eventName)) {
      throw new Error(
        `Wrong AsyncResource eventName was provided: ${eventName}`
      )
    }

    this.emitter.on(eventName, listener)

    return () => this.emitter.off(eventName, listener)
  }

  off(eventName, listener) {
    if (!listener) {
      this.emitter.removeAllListeners(eventName)
      return
    }
    this.emitter.off(eventName, listener)
  }

  destroy() {
    this.emitter.removeAllListeners()
  }

  _handleStateChange(prevState) {
    if (this.state !== prevState) {
      this.emitter.emit(this.state, [this.id])
    }
  }
}
